/* istanbul ignore file */
import SearchLocation from './SearchLocation';

export default SearchLocation;
